import { c as _c } from "react/compiler-runtime";
import { DatepickerCalendarLocaleType, DatepickerSelectedDateType } from "@website/ui/datepicker";
import every from "lodash-es/every";
import isNaN from "lodash-es/isNaN";
import { useEffect, useState } from "react";
export const useDate = defaultValue => {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [date, setDate] = useState(t0);
  const [calendarLocale, setCalendarLocale] = useState("persian");
  let t1;
  let t2;
  if ($[1] !== defaultValue) {
    t1 = () => {
      every(defaultValue, _temp) ? setDate(defaultValue) : setDate([]);
    };
    t2 = [defaultValue];
    $[1] = defaultValue;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (value, calendarLocale_0) => {
      setDate(value);
      setCalendarLocale(calendarLocale_0 as DatepickerCalendarLocaleType);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onChangeDate = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setDate([]);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const onEmptyDate = t4;
  let t5;
  if ($[6] !== calendarLocale || $[7] !== date) {
    t5 = {
      date,
      calendarLocale,
      onChangeDate,
      onEmptyDate,
      fromDateTitle: "\u062A\u0627\u0631\u06CC\u062E \u0631\u0641\u062A",
      toDateTitle: "\u062A\u0627\u0631\u06CC\u062E \u0628\u0631\u06AF\u0634\u062A"
    };
    $[6] = calendarLocale;
    $[7] = date;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
function _temp(date_0) {
  return !isNaN(date_0.year) && !isNaN(date_0.month) && !isNaN(date_0.day);
}